export enum EFills {
  Clear = 'clear',
  Outline = 'outline',
  Solid = 'solid',
  Default = 'default'
}
